export const VEHICLE_DISCOVERY_STATUSES = [
  { value: "DISCOVERED", label: "Discovered" },
  { value: "QUEUED_FOR_DETAIL", label: "Queued for detail" },
  { value: "DETAIL_FETCHING", label: "Detail fetching" },
  { value: "DETAIL_FETCHED", label: "Detail fetched" },
  { value: "DETAIL_FAILED", label: "Detail failed" },
  { value: "IGNORED", label: "Ignored" },
];

export const DISCOVERY_ADAPTER_SOURCE_KEYS = new Set(["TUCARRO"]);
export const DEALER_ADAPTER_SOURCE_KEYS = new Set(["SERVIAUTOS"]);

const INGEST_APPROVED_SOURCE_STATUSES = new Set(["APPROVED", "ACTIVE"]);
const INGEST_APPROVED_REVIEW_STATUSES = new Set(["APPROVED", "APPROVED_WITH_LIMITS"]);

function ingestGateChecks(source, reasons) {
  if (!source.allowedToIngest) reasons.push("Not allowed to ingest.");
  if (!source.isActive) reasons.push("Source is not active.");
  if (!INGEST_APPROVED_SOURCE_STATUSES.has(source.sourceStatus)) {
    reasons.push(`Status must be APPROVED or ACTIVE (current: ${source.sourceStatus}).`);
  }
  if (source.sourceStatus === "BLOCKED") reasons.push("Source is blocked.");
  for (const [label, value] of [
    ["Robots", source.robotsReviewStatus],
    ["Terms", source.termsReviewStatus],
    ["Access", source.accessReviewStatus],
  ]) {
    if (!INGEST_APPROVED_REVIEW_STATUSES.has(value)) {
      reasons.push(`${label} review not approved.`);
    }
  }
}

export function canRunVehicleDiscoveryUi(source) {
  const reasons = [];
  if (!source) return { allowed: false, reasons: ["No source."] };

  if (source.sourceType !== "MARKETPLACE") {
    reasons.push("Source must be type MARKETPLACE.");
  }
  if (!DISCOVERY_ADAPTER_SOURCE_KEYS.has(source.sourceKey)) {
    reasons.push(`Discovery adapter not available for ${source.sourceKey}.`);
  }
  ingestGateChecks(source, reasons);
  return { allowed: reasons.length === 0, reasons };
}

export function canRunVehicleDealerDiscoveryUi(source) {
  const reasons = [];
  if (!source) return { allowed: false, reasons: ["No source."] };

  if (source.sourceType !== "DEALER") {
    reasons.push("Source must be type DEALER.");
  }
  if (!DEALER_ADAPTER_SOURCE_KEYS.has(source.sourceKey)) {
    reasons.push(`Dealer discovery adapter not available for ${source.sourceKey}.`);
  }
  ingestGateChecks(source, reasons);
  return { allowed: reasons.length === 0, reasons };
}

export function canRunVehicleDetailFetchUi(source) {
  if (source?.sourceType === "DEALER") {
    return canRunVehicleDealerDetailFetchUi(source);
  }
  return canRunVehicleDiscoveryUi(source);
}

export function canRunVehicleDealerDetailFetchUi(source) {
  const discovery = canRunVehicleDealerDiscoveryUi(source);
  if (!discovery.allowed) return discovery;
  return discovery;
}
